import { render } from "./TvmTransportTypes.vue?vue&type=template&id=572934ca&scoped=true"
import script from "./TvmTransportTypes.js?vue&type=script&lang=js&external"
export * from "./TvmTransportTypes.js?vue&type=script&lang=js&external"

import "./TvmTransportTypes.vue?vue&type=style&index=0&id=572934ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572934ca"]])

export default __exports__